import { useEffect, useLayoutEffect } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import { Layout } from "layouts";
import { Page404 } from "pages/Page404";
import { LoginPage } from "pages/LoginPage";
import { useAppDispatch, useAppSelector } from "app/hooks";
import { loadUser, selectAuth } from "app/services/auth/authSlice";
import { DashboardPage } from "pages/DashboardPage";
import { UserPage } from "pages/UserPage";
import { DateWiseReportPage } from "pages/DateWiseReportPage";
import { FingerPrintPage } from "pages/ConsumerPage";
import { ImageUploadPage } from "pages/ImageUploadPage";
import { ConnectionPage } from "pages/ConnectionPage";
import { AccountPage } from 'pages/AccountPage'
import { AgentPage } from 'pages/AgentPage'
import { ROUTES } from "definitions/constant/routes";
import ProductMain from "pages/ecom/ProductMain";
import RefilSale from "pages/RefilSalePage";
import Transactions from "pages/TransactionsPage";
import { isTokenExpired } from "Service/Service";
import InvoiceManagement from "pages/InvoiceManagement";
import ConsumerSearch from "pages/ConsumerSearch";
import ConsumerRegistration from "pages/ConsumerRegistration";
import AgentManagement from "pages/AgentManagement";
import UserManagement from "pages/UserManagement";
import { ConfirmDialogProvider } from "common/ConfirmDialogProvider";
import PrivateRoute from "components/auth";
import RefillTransactionTable from "features/refilsale/RefillSaleSummary";
import CashMemoPunch from "features/cashmemo/CashMemo";
import AgentDashBoard from "pages/AgentDashBoard";
import AgentView from "pages/AagentView";


function App() {
  // route
  const navigate = useNavigate();
  const location = useLocation();
  // redux
  const auth = useAppSelector(selectAuth);
  const dispatch = useAppDispatch();
  // hooks
  useLayoutEffect(() => {
    dispatch(loadUser());
  }, []);

  useEffect(() => {
    const isExpired = isTokenExpired();
    const pathName = location.pathname;
    if (!isExpired) {
      let destination = pathName;
      if (pathName === ROUTES.login) {
        if (auth.user?.role === 'user') {
          destination = '/agent-dashboard';
        } else {
          destination = ROUTES.root;
        }
      }
      navigate(destination, { replace: true });
    } else navigate(ROUTES.login, { replace: true });
  }, [auth.token, auth.user]);



  return (
    <div className="App">
      <header className="App-header">
        <ConfirmDialogProvider>
            <Routes>
              <Route path={ROUTES.root} element={<Layout />}>
                <Route path={ROUTES.root} element={<PrivateRoute><DashboardPage /></PrivateRoute>} />
                <Route path={ROUTES.find} element={<PrivateRoute><ConsumerSearch /></PrivateRoute>} />
                <Route path={ROUTES.user} element={<PrivateRoute><UserPage /></PrivateRoute>} />
                <Route path={ROUTES.trash} element={<PrivateRoute><FingerPrintPage /></PrivateRoute>} />
                <Route path={ROUTES.dailyReport} element={<PrivateRoute><DateWiseReportPage /></PrivateRoute>} />
                <Route path={ROUTES.imageUpload} element={<PrivateRoute><ImageUploadPage /></PrivateRoute>} />
                <Route path={ROUTES.connection} element={<PrivateRoute><ConnectionPage /></PrivateRoute>} />
                <Route path={ROUTES.account} element={<PrivateRoute><AccountPage /></PrivateRoute>} />
                <Route path={ROUTES.agent} element={<PrivateRoute><AgentPage /></PrivateRoute>} />
                <Route path={ROUTES.refilsales} element={<PrivateRoute><RefilSale /></PrivateRoute>} />
                <Route path={ROUTES.transaction} element={<PrivateRoute><Transactions /></PrivateRoute>} />
                <Route path={ROUTES.invoices} element={<PrivateRoute><InvoiceManagement /></PrivateRoute>} />
                <Route path={ROUTES.consumer} element={<PrivateRoute><ConsumerSearch /></PrivateRoute>} />
                <Route path={ROUTES.account} element={<PrivateRoute><AccountPage /></PrivateRoute>} />
                <Route path={ROUTES.register} element={<PrivateRoute><ConsumerRegistration /></PrivateRoute>} />
                <Route path={ROUTES.agentManagement} element={<PrivateRoute><AgentManagement /></PrivateRoute>} />
                <Route path={ROUTES.userManagement} element={<PrivateRoute><UserManagement /></PrivateRoute>} />
                <Route path={ROUTES.proudct} element={<PrivateRoute><ProductMain /></PrivateRoute>} />
                <Route path={ROUTES.refillTransactions} element={<PrivateRoute><RefillTransactionTable /></PrivateRoute>} />
                <Route path={ROUTES.cashMemoPunch} element={<PrivateRoute><CashMemoPunch /></PrivateRoute>} />
                <Route path={ROUTES.agentDashboard} element={<PrivateRoute><AgentDashBoard /></PrivateRoute>} />
                <Route path={ROUTES.agentView} element={<PrivateRoute><AgentView /></PrivateRoute>} />

              </Route>
              <Route path={ROUTES[404]} element={<Page404 />} />
              <Route path={ROUTES.login} element={<LoginPage />} />
            </Routes>
          </ConfirmDialogProvider>
      </header>
    </div>
  );
}

export default App;
